import { useEffect } from "react";
import { WorkflowStep } from "@/types/workflow";
import { DocumentGeneratorContent } from "./DocumentGeneratorContent";
import { useDocumentGenerator } from "./DocumentGeneratorProvider";
import { useQueryClient } from "@tanstack/react-query";
import { useToast } from "@/hooks/use-toast";

export interface DocumentGeneratorProps {
  step?: WorkflowStep | null;
  existingDocuments?: any[];
  onClose?: () => void;
  onSuccess?: () => void;
  isWorkflowGeneration?: boolean;
}

export function DocumentGenerator({ 
  step, 
  existingDocuments, 
  onClose,
  onSuccess,
  isWorkflowGeneration = false 
}: DocumentGeneratorProps) {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const {
    isLoading,
    previewContent,
    generateDocument,
    setPreviewContent
  } = useDocumentGenerator();

  // Auto-generate document for workflow steps
  useEffect(() => {
    if (isWorkflowGeneration && step && !previewContent) {
      console.log("Starting workflow document generation for step:", step.title);
      generateDocument().catch(error => {
        console.error("Error generating document:", error);
        toast({
          variant: "destructive",
          title: "Feil ved dokumentgenerering",
          description: "Kunne ikke generere dokumentet. Vennligst prøv igjen.",
        });
      });
    }
  }, [step, generateDocument, previewContent, toast, isWorkflowGeneration]);

  return (
    <DocumentGeneratorContent
      step={step}
      existingDocuments={existingDocuments}
      onClose={onClose}
      onSuccess={onSuccess}
      isWorkflowGeneration={isWorkflowGeneration}
      setPreviewContent={setPreviewContent}
    />
  );
}